import * as ValueSourceType from '../../constant/ValueSourceType'

let group_unique_key = 1

export default class ValueSourceOptionsGroup {
    group_label = ''
    group_source_type = ''
    /** @type {Array} */
    options = []

    group_unique_key = '0'

    constructor() {
        this.group_unique_key = "" + group_unique_key
        group_unique_key++
    }

    isEmpty() {
        return this.group_source_type === ValueSourceType.IS_EMPTY
    }

    isDefault() {
        return this.group_source_type === ValueSourceType.IS_DEFAULT
    }
}
